import React, { useEffect, useRef, useState } from 'react';
import { getMarkDown, formatCardLoadTiming, useNextButtonWidthClass } from '../utils';
import '../../../stylesheets/triagebot/DisclaimerNew.scss';
import {useDetectIOS,useDetectAndroid} from '../utils';
import { useTiming } from '../TimingContext';
import { useCardLoadTiming } from '../hooks/useCardLoadTiming';

const DisclaimerMessage = ({ message, sendMessage, disabled }) => {   

    const [submitted, setSubmitted] = useState(false);  
    const [selectedButton, setSelectedButton] = useState(null);  
    const nextButtonClass = useNextButtonWidthClass();
    const isDisabledRef = React.useRef();
    const headingRef = useRef(null);
    const isDisabled = submitted || disabled;
    isDisabledRef.current = isDisabled;  

    const headerText = (message.data && message.data.length && message.data[0].headerText)
        ? message.data[0].headerText
        : ''

    const bodyText  = (message.data && message.data.length && message.data[0].subHeaderText)
        ? message.data[0].subHeaderText
        : ''


    const credits = (message.data && message.data.length)
        ? message.data[0].credits
        : ''

    const buttons = (Array.isArray(message.buttons))
        ? message.buttons
        : []
               
    const {isIOS} = useDetectIOS();
    const {isAndroid} = useDetectAndroid();
    
    const iosDisclaimerUrl=message.data[0].iOSHomeURL;
    const androidDisclaimerUrl=message.data[0].androidHomeURL;

    const [isCancelClicked, setisCancelClicked] = useState(false);

    const cardName = (message.data && message.data[0] && message.data[0].question_id) ? message.data[0].question_id : "Disclaimer";
    const { logTiming } = useTiming();

    useCardLoadTiming({
            sentAt: message._sentAt,
            cardName,
            logTiming,
            formatCardLoadTiming
        });

    useEffect(() => {
        requestAnimationFrame(() => {
            headingRef.current?.focus({ preventScroll: true });
        });
    }, [cardName]);

    const buttonPress = (event, button,key) => {
        if (isDisabled) return;
       
        let redirectUrl = null;
        if(key === 1)
            {
            if (isIOS && iosDisclaimerUrl) {
            // For iOS iPhone/iPad
            redirectUrl = iosDisclaimerUrl;

            } else if (isAndroid && androidDisclaimerUrl) {
            // For Android Phone/Tab
            // Convert deep link to intent URL for Android
            redirectUrl = androidDisclaimerUrl;
            }

            if (redirectUrl) {
            setisCancelClicked(true);
            sendMessage('message', 'Cancel', 'Cancel');
            setTimeout(() => {
            window.location.href = redirectUrl;
            }, 3000);
            } 

            else {
            // For web app deep link
            setisCancelClicked(true);
            sendMessage('message', 'Cancel', 'Cancel');
            window.top.location.href = message.data[0].myChartLink;
            }                
                return;
            }
            else{
             setSubmitted(true);
             sendMessage('message', "Agree", Date.now(), cardName);
            }
         setSelectedButton(button.value);
    }

    return (
        <div className={isDisabled ? 'disabled disclaimer new card' : 'disclaimer new card'}>
            <div className={isCancelClicked ? 'div-disabled' : ''}>
            <div className='content' >
                <h2 className='header' ref={headingRef} tabIndex={-1}>
                    <b>{headerText}</b>
                </h2>                
                <div className='body'>
                    {getMarkDown(bodyText)}                   
                </div>
            </div>
            <div className='buttonStyles'>            
             {buttons.map((button, key) => {
                const isCancel = key === 1;
                const buttonClass = isCancel
                    ? 'secondary-button-color '
                    : ' ';
                return (
                    <button
                        key={key}
                        className={`agree-select ${isCancel ? 'no' : 'yes'} ${buttonClass} selection-card-button buttonAlign ${nextButtonClass} ${selectedButton === button.value ? 'submit-selected' : ''}`.trim()}
                        onClick={(event) => buttonPress(event, button,key)}
                        disabled={isDisabled}
                    >
                        {button.displayText}
                    </button>
                );
             })}  
             </div>
             </div>           
        </div>
    );
}

export default DisclaimerMessage;
